<template>
  <v-dialog v-bind="$attrs" v-on="$listeners" width="320">
    <v-card>
      <v-card-title class="text-center">付费界面预览</v-card-title>
      <v-card-text>
        <div class="qrcode-wrapper" v-if="qrcodeDataUrl">
          <img class="qrcode" :src="qrcodeDataUrl" alt="qrcode" />
        </div>
        <div class="link-wrapper">
          <v-text-field :value="url" readonly dense>
            <template #append>
              <v-btn class="btn-link-copy" text rounded @click="onCopyLink">
                <v-icon color="primary">{{ mdiContentCopy }}</v-icon>
              </v-btn>
            </template>
          </v-text-field>
        </div>
      </v-card-text>
      <v-card-actions>
        <div class="action-wrapper">
          <v-btn class="btn-action" color="primary" @click="onOpenLink">访问链接</v-btn>
          <v-btn class="btn-action" color="secondary" @click="onClose">关闭</v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { copyTextToClipboard } from '@/plugins/copyText'
import { mdiContentCopy } from '@mdi/js'
import QRCode from 'qrcode'

export default {
  props: {
    url: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      mdiContentCopy,
      qrcodeDataUrl: null,
    }
  },
  async mounted() {
    this.$watch('url', async () => {
      await this.renderQrcodeValue()
    })
  },
  methods: {
    async renderQrcodeValue() {
      if (!this.url) {
        return
      }
      let options = { scale: 8 }
      try {
        let dataUrl = await QRCode.toDataURL(this.url, options)
        this.qrcodeDataUrl = dataUrl
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err)
      }
    },
    onCopyLink() {
      if (!this.url) {
        return
      }
      if (copyTextToClipboard(this.url)) {
        this.$toasted.success('已复制到剪贴板')
      }
    },
    onOpenLink() {
      if (!this.url) {
        return
      }
      window.open(this.url, '_blank')
    },
    onClose() {
      this.$emit('input', false)
    },
  },
}
</script>

<style lang="less" scoped>
.qrcode-wrapper {
  min-height: 200px;
  text-align: center;
  .qrcode {
    width: 200px;
    max-height: 300px;
  }
}
.btn-link-copy {
  width: 40px;
  position: relative;
  margin-right: -16px;
}
.action-wrapper {
  width: 100%;
  padding-bottom: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
  .btn-action {
    min-width: 96px;
  }
}
</style>
